import { IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "proxy-polyfill";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import { createRoot } from "react-dom/client";
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router";
import { msalConfig } from "./components/auth/msal-config";
import Root from "./components/root";
import * as serviceWorker from "./serviceWorker";
import { AppStoreProvider, storeDefault } from "./store";
import "./style/app.scss";
import { getIEVersion } from "./utils";

// Route configuration
const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<Root />} />));

// React Query client
const queryClient = new QueryClient();

const notSupportedBrowser = () => {
  return (
    <div className="dark" style={{ height: "100%" }}>
      <div className="signin">
        <div className="watermark">
          <i className="icon icon-econ" />
          <div className="product">Ericsson Customer Order Dashboard</div>
        </div>
        <div className="unsupported-browser">
          Sorry, we are not supporting the current browser.
          <br />
          <br />
          Please use Microsoft Edge ©, Google Chrome © or Mozilla Firefox ©.
        </div>
        <div className="footer">
          © Ericsson AB 2013-2025 - All rights reserved. <br />
          No part of this software may be reproduced in any form without the written permission of
          the copyright holder.
        </div>
      </div>
    </div>
  );
};

const AppWithMsal = (msalInstance: IPublicClientApplication) => {
  return (
    <MsalProvider instance={msalInstance}>
      <AppStoreProvider initialValue={storeDefault}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AppStoreProvider>
    </MsalProvider>
  );
};

const renderWithAuth = (msalInstance: IPublicClientApplication) => {
  createRoot(document.getElementById("root")!).render(
    getIEVersion() > 0 ? notSupportedBrowser() : AppWithMsal(msalInstance)
  );
  serviceWorker.unregister();
};

// MSAL v.3.x (msal-browser v.3.0 and later) requires async instantiation.
PublicClientApplication.createPublicClientApplication(msalConfig)
  .then((msalInstance: IPublicClientApplication) => renderWithAuth(msalInstance))
  .catch((e: Error) => console.error(e));
